var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpSwitchAfter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6794_3608)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#6D47FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#F4F4F4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5789 23.6376C11.5789 24.39 10.9629 25 10.2105 25C9.4581 25 8.84211 24.39 8.84211 23.6376C8.84211 22.8852 9.4581 22.2752 10.2105 22.2752C10.9629 22.2752 11.5789 22.8852 11.5789 23.6376ZM11.5789 18.1881C11.5789 18.9405 10.9629 19.5505 10.2105 19.5505C9.45811 19.5505 8.84211 18.9405 8.84211 18.1881C8.84211 17.4357 9.45811 16.8257 10.2105 16.8257C10.9629 16.8257 11.5789 17.4357 11.5789 18.1881ZM11.5789 12.7386C11.5789 13.491 10.9629 14.101 10.2105 14.101C9.45811 14.101 8.84211 13.491 8.84211 12.7386C8.84211 11.9862 9.45811 11.3762 10.2105 11.3762C10.9629 11.3762 11.5789 11.9862 11.5789 12.7386ZM28 23.6376C28 24.39 27.39 25 26.6376 25H15.6782C14.9257 25 14.3158 24.39 14.3158 23.6376C14.3158 22.8852 14.9257 22.2752 15.6782 22.2752H26.6376C27.39 22.2752 28 22.8852 28 23.6376ZM28 18.1881C28 18.9405 27.39 19.5505 26.6376 19.5505H15.6782C14.9257 19.5505 14.3158 18.9405 14.3158 18.1881C14.3158 17.4357 14.9257 16.8257 15.6782 16.8257H26.6376C27.39 16.8257 28 17.4357 28 18.1881ZM28 12.7386C28 13.491 27.39 14.101 26.6376 14.101H15.6782C14.9257 14.101 14.3158 13.491 14.3158 12.7386C14.3158 11.9862 14.9257 11.3762 15.6782 11.3762H26.6376C27.39 11.3762 28 11.9862 28 12.7386Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6794_3608",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6794_3608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6794_3608",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpSwitchAfter);
export default __webpack_public_path__ + "static/media/BPSwitchAfter.566b3b9822edd90a213116c708871cff.svg";
export { ForwardRef as ReactComponent };